// Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from 'react';
import { GoogleDrive } from './GoogleDrive'; 

// Define props for the component
interface ListAccountSolutionDocumentProps {
  driveLocation: string; // The Google Drive folder URL for the account
}

// Functional component that renders the GoogleDrive component
const ListAccountSolutionDocument: React.FC<ListAccountSolutionDocumentProps> = ({ driveLocation }) => {
  return (
    <div> 
      <GoogleDrive driveLocation={driveLocation} /> {/* Render GoogleDrive with driveLocation prop */}
    </div>
  );
};

export default ListAccountSolutionDocument; 
